export default "__VITE_ASSET__twUJByoL__"